module.exports = __webpack_public_path__ + "static/media/GooglePlay@2x.5b366ff7.png";